/*
 * castle-rat-geo.js — region-aware link redirect for nav signs.
 *
 * A sign with a "Region redirect URL" set (data-cr-geo-href) sends visitors in
 * a configured set of countries (data-cr-geo-countries, ISO-3166 alpha-2) to
 * that URL instead of its normal link — e.g. Castle Market → the Loma Vista
 * international bodega for UK/Europe.
 *
 * The store has no Shopify Markets geolocation, so country is resolved CLIENT
 * SIDE from a geo-IP endpoint (data-cr-geo-api, JSON with a country / country_code
 * field), cached in sessionStorage so it's one lookup per visit. On a match the
 * sign hrefs are rewritten in place; non-matching visitors (and any failure —
 * offline, blocked, bad response) keep the default links untouched.
 *
 * No clicks are ever intercepted or delayed: the lookup runs in the background
 * and only swaps the href when it resolves, so US / non-matching visitors get
 * instant, normal navigation. Trade-off: a brand-new visitor who clicks the
 * sign within the first few hundred ms — before the lookup returns — uses the
 * default link; it's correct on every page after (cached). For zero-window,
 * server-side detection (Shopify Markets + Liquid) would be the upgrade.
 */
(function () {
  var root = document.querySelector('[data-cr-geo-api]');
  if (!root) return;

  var signs = [].slice.call(document.querySelectorAll('[data-cr-geo-href]'));
  if (!signs.length) return;

  var api = root.getAttribute('data-cr-geo-api');
  var countries = (root.getAttribute('data-cr-geo-countries') || '')
    .toUpperCase()
    .split(',')
    .map(function (c) { return c.trim(); })
    .filter(Boolean);
  if (!api || !countries.length) return;

  var CACHE_KEY = 'cr_geo_country';

  function apply(code) {
    if (countries.indexOf((code || '').toUpperCase()) === -1) return;
    signs.forEach(function (a) {
      var dest = a.getAttribute('data-cr-geo-href');
      if (dest) a.setAttribute('href', dest);
    });
  }

  // Cached result from earlier this session — apply instantly, no network.
  var cached = null;
  try { cached = sessionStorage.getItem(CACHE_KEY); } catch (e) {}
  if (cached !== null) {
    apply(cached);
    return;
  }

  // Fresh lookup. Any failure → leave the default links untouched.
  fetch(api, { mode: 'cors', credentials: 'omit' })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var code = (data.country || data.country_code || data.countryCode || '').toUpperCase();
      try { sessionStorage.setItem(CACHE_KEY, code); } catch (e) {}
      apply(code);
    })
    .catch(function () {});
})();
